import { render, staticRenderFns } from "./TaskExercisesForm.vue?vue&type=template&id=5f5c95ff&lang=pug"
import script from "./TaskExercisesForm.vue?vue&type=script&lang=js"
export * from "./TaskExercisesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports